export default __webpack_public_path__ + "static/media/eye-alt.2f69c823.svg";